import { render } from "./Protocols.vue?vue&type=template&id=586bb8e3"
import script from "./Protocols.vue?vue&type=script&lang=js"
export * from "./Protocols.vue?vue&type=script&lang=js"

import "./Protocols.vue?vue&type=style&index=0&id=586bb8e3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QSelect});
